export class AnnouncementBanner {
  header: string;
  body: string;

  constructor(header?: string, body?: string, date?: string) {
    this.header = header;
    this.body = body.replace('<date>', `<span class="font-weight-bold font-italic"><u>${date}</u></span>`);
  }
}
